export default {
	rules: {
		required: "Required",
		requiredTrailingSpace: "Required. ",
		onlyWhitespace: "Input must not consist of whitespace only.",
		maxLength35: "Maximum 35 characters allowed.",
		maxLength50: "Maximum 50 characters allowed.",
		maxLength50TrailingSpace: "Maximum 50 characters allowed. ",
		invalidCharacters: 'Contains invalid characters "* ^ { } [ ] = < > |"',
		invalidEmail: "Must be a valid e-mail address. ",
		notANumber: "Must be a number.",
		mustBePositive: "Must be positive.",
		noDecimals: "No decimal places allowed",
		notAnInteger: "Must be a whole number.",
		outOfRange0To1000: "Must be between 0 and 1000",
	},
	messages: {
		allUsers: "All Users",
		savedCartQuantitySet:
			"The quantity for article {articleId} was set to {quantity} pcs. in the parts list.",
		savedCartQuantityError: "The quantity could not be adjusted.",
		savedCartRemoveArticleError: "The article could not be removed from the parts list.",
		savedCartAddArticleError: "The article could not be added to the parts list.",
		addressDeleted: "The address was deleted.",
		addressDeleteError: "The address could not be deleted.",
		addressSetPreferred: "The address was marked as favourite.",
		addressSetPreferredError: "The address could not be marked as favourite.",
		weldlineOne: "1 weld seam",
		weldlineMultiple: "{count} weld seams",
		cornerOne: "1 corner",
		cornerMultiple: "{count} corners",
		cleaned: "cleaned",
		notCleaned: "not cleaned",
		powderFinishMatt: "Matt",
		powderFinishGlossy: "Gloss",
		notAvailable: "Not available",
		powderStructureSmooth: "Smooth",
		powderStructureFine: "Fine",
		powderStructureRough: "Coarse",
	},
};
